import styled, { css } from "styled-components";

export const RegisterStoreContainer = styled.div`
  padding: 2rem;

  @media (max-width: ${(props) => props.theme.responsiveDesign.sm}) {
    padding: 1.5rem;

    h3 {
      font-size: ${(props) => props.theme.fontSize.XS};
    }
  }
`;

export const RegisterStoreForm = styled.form`
  margin-top: 2.5rem;

  h3 {
    font-size: ${(props) => props.theme.fontSize.XS};
    font-weight: ${(props) => props.theme.fontWeight.Semibold};
    font-family: ${(props) => props.theme.fontFamily.Roboto};
    color: ${(props) => props.theme.colors["gray-850"]};

    margin-top: 2rem;
    @media (max-width: ${({ theme }) => theme.responsiveDesign.sm}) {
      margin-top: 1rem;
    }
  }

  @media (max-width: ${({ theme }) => theme.responsiveDesign.sm}) {
    margin-top: 0;
  }
`;

export const FieldsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  align-items: flex-end;
  gap: 1.5rem;

  margin: 1.7rem 0;

  @media (max-width: ${({ theme }) => theme.responsiveDesign.sm}) {
    margin: 1rem 0 0 0;
    display: flex;
    width: 100%;
    flex-direction: column;
    gap: 1rem;
  }
`;

export const ButtonAlignContainer = styled.div`
  display: flex;
  justify-content: flex-end;

  @media (max-width: ${({ theme }) => theme.responsiveDesign.sm}) {
    width: 100%;
    margin-top: 1rem;
    button {
      width: 100%;
    }
  }
`;

export const DefaultShopUsersDescription = styled.p`
  color: ${(props) => props.theme.newColors["gray-900"]};
  margin-bottom: 1rem;
`;

export const DefaultShopUsersList = styled.ul`
  max-height: 24rem;
  overflow-y: auto;
  list-style: none;
  padding: 0;
  margin: 0 0 1.5rem;

  li {
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
    padding: 0.75rem 0;
    border-bottom: 1px solid ${(props) => props.theme.colors["gray-100"]};
    overflow-wrap: anywhere;
  }
`;

export const DefaultShopUsersActions = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const Separator = styled.div`
  border-top: 1px solid ${(props) => props.theme.colors["gray-100"]};
  margin: 2.5rem 0;

  @media (max-width: ${({ theme }) => theme.responsiveDesign.sm}) {
    margin: 1.5rem 0;
  }
`;

export const PrinterTitleAlign = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (max-width: ${({ theme }) => theme.responsiveDesign.sm}) {
    align-items: start;
    gap: 1rem;
    flex-direction: column;
    button {
      width: 100%;
    }
  }
`;

interface RowValueContainerProps {
  isAcvite?: boolean;
}

export const RowValueContainer = styled.div<RowValueContainerProps>`
  display: inline-block;
  align-items: center;
  justify-content: center;
  height: 1.5rem;
  border: 1px solid ${(props) => props.theme.newColors["gray-500"]};
  border-radius: 0.75rem;
  text-align: center;

  padding: 0.25rem 0.5rem;

  font-size: ${(props) => props.theme.fontSize.XXXS};
  color: ${(props) => props.theme.newColors["gray-700"]};

  ${(props) =>
    props.isAcvite &&
    css`
      color: ${(props) => props.theme.newColors["green-700"]};
      font-weight: ${(props) => props.theme.fontWeight.Bold};
    `};
`;

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 0.5rem;

  svg {
    cursor: pointer;
    transition: opacity 0.2s;

    &:hover {
      opacity: 0.8;
    }
  }
`;

export const Title = styled.h2`
  font-size: ${({ theme }) => theme.fontSize.SM};
  font-weight: ${({ theme }) => theme.fontWeight.Semibold};
  font-family: ${({ theme }) => theme.fontFamily.Roboto};
  color: ${({ theme }) => theme.colors["gray-850"]};

  @media (max-width: ${({ theme }) => theme.responsiveDesign.sm}) {
    font-size: ${({ theme }) => theme.fontSize.XS};
  }
`;

export const SelectTitle = styled.span`
  font-size: ${(props) => props.theme.fontSize.XXS};
  font-weight: ${(props) => props.theme.fontWeight.Regular};
  font-family: ${(props) => props.theme.fontFamily.Roboto};
  color: ${(props) => props.theme.colors["black-925"]};
`;

export const InputTitle = styled.span`
  font-size: ${(props) => props.theme.fontSize.XXXS};
  font-weight: ${(props) => props.theme.fontWeight.Regular};
  font-family: ${(props) => props.theme.fontFamily.Roboto};
  color: ${(props) => props.theme.colors.black};

  .required {
    color: ${(props) => props.theme.colors["red-900"]};
    margin-left: 0.375rem;
  }
`;

export const DrawerContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;
